import { render, staticRenderFns } from "./mallOrder.vue?vue&type=template&id=58929e5f&scoped=true&"
import script from "./mallOrder.vue?vue&type=script&lang=js&"
export * from "./mallOrder.vue?vue&type=script&lang=js&"
import style0 from "./mallOrder.vue?vue&type=style&index=0&id=58929e5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58929e5f",
  null
  
)

export default component.exports